/*
 * Re-renderiza `sections/ws-cart-incentives.liquid` via Section Rendering
 * API sempre que o carrinho muda (`PUB_SUB_EVENTS.cartUpdate`, publicado
 * por `assets/cart.js` — core, não editado) — sem isso a barra de frete
 * grátis/promoções ficava presa no valor de quando a página `/cart`
 * carregou, só atualizando de verdade num reload manual (achado ao vivo,
 * reportado pelo usuário). `subscribe`/`PUB_SUB_EVENTS` são globais
 * carregados sempre via `assets/pubsub.js`/`constants.js`
 * (`layout/theme.liquid`), mesmo mecanismo que `ws-tax-note.liquid`/
 * `ws-size-guide.liquid` já usam.
 *
 * O id real do wrapper (`shopify-section-{{ section.id }}`) NÃO é
 * `shopify-section-cart-incentives` — pra section dentro de um template
 * JSON, `section.id` em runtime vem prefixado com o template
 * (`template--<id>__cart-incentives`), confirmado ao vivo via DevTools.
 * Por isso o id é lido do próprio DOM (`.closest('.shopify-section')`,
 * mesmo raciocínio de `document.getElementById('main-cart-items').dataset.id`
 * em `assets/cart.js`), nunca hardcoded.
 */
(function () {
  var wrapper = document.currentScript && document.currentScript.closest('.shopify-section');
  if (!wrapper || !wrapper.id) return;

  /*
   * Guarda de sequência. Cada refresh() recebe um número crescente e só a
   * resposta do pedido MAIS RECENTE pode escrever no DOM.
   *
   * Sem isso: duas mudanças de carrinho seguidas disparam dois fetch; se o
   * primeiro demorar mais que o segundo (rede móvel, servidor lento), ele
   * chega DEPOIS e reescreve a barra com o estado antigo do carrinho. A
   * divergência não se corrige sozinha — fica até o próximo cartUpdate ou
   * um reload. Reproduzido em 08/09/2026 invertendo a ordem de entrega das
   * respostas: carrinho real $195.94 (frete grátis atingido) exibindo
   * "You're $52.03 away from free shipping".
   *
   * Só descarte de resposta obsoleta, sem AbortController: o problema aqui
   * é exclusivamente "quem escreve por último vence", não consumo de rede
   * (a resposta é ~1.7KB). Abortar exigiria distinguir cancelamento
   * esperado de falha real sem ganho correspondente.
   */
  var latestRequest = 0;

  // Devolve a promise: quem publica o cartUpdate e espera o redesenho (a barra
  // do brinde, assets/ws-cart-rewards.js) espera esta section também.
  function refresh() {
    var requestId = ++latestRequest;

    return fetch(window.location.pathname + '?section_id=' + wrapper.id.replace(/^shopify-section-/, ''))
      .then(function (response) {
        if (!response.ok) throw new Error('ws-cart-incentives: HTTP ' + response.status);
        return response.text();
      })
      .then(function (responseText) {
        // Resposta obsoleta: outro refresh() começou depois deste. Descarta
        // sem tocar no DOM.
        if (requestId !== latestRequest) return;

        var doc = new DOMParser().parseFromString(responseText, 'text/html');
        var updated = doc.getElementById(wrapper.id);
        // Section ausente na resposta: mantém o conteúdo atual em vez de
        // esvaziar o componente. Carrinho vazio NÃO cai aqui — nesse caso a
        // section responde normalmente, só sem conteúdo interno
        // (`{% if cart != empty %}`), e a barra deve mesmo desaparecer.
        if (!updated) return;

        wrapper.innerHTML = updated.innerHTML;
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
})();
